import React, { useEffect, useState } from 'react';
import { FaMoon, FaSun } from 'react-icons/fa';

export default function AdminUsers() {
  const [dark, setDark] = useState(true);
  const [users, setUsers] = useState([]);
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
const API_URL = process.env.REACT_APP_API_URL;

  useEffect(() => {
    const fetchUsers = async () => {
      setLoading(true);
      try {
        const res = await fetch('https://api.mogym.ir/api/admin/users', {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('admin_token')}`
          }
        });
        const data = await res.json();
        if (!res.ok) throw new Error(data.Message);
        setUsers(data.Result || []);
      } catch {
        setError('دریافت کاربران با خطا مواجه شد.');
      }
      setLoading(false);
    };

    fetchUsers();
  }, []);

  const filteredUsers = users.filter(user =>
    user.Phone.includes(search)
  );

  return (
    <div className={dark ? 'dark' : ''}>
      <div className="min-h-screen bg-white dark:bg-[#0e1015] text-black dark:text-white px-4 py-10 font-vazir">
        <div className="max-w-4xl mx-auto space-y-6">
          <h1 className="text-2xl font-bold text-center mb-6">مدیریت کاربران</h1>

          {/* جستجو */}
          <div className="flex justify-center mb-4">
            <input
              type="text"
              placeholder="جستجو بر اساس شماره موبایل..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className="w-full max-w-md p-2 border rounded-xl bg-white dark:bg-[#1c1f2b] dark:border-gray-600"
            />
          </div>

          {loading && <p className="text-center">در حال دریافت کاربران...</p>}
          {error && <p className="text-red-500 text-center">{error}</p>}

          {/* لیست کاربران */}
          <div className="space-y-4">
            {filteredUsers.map((user, idx) => (
              <div
                key={idx}
                className="bg-gray-50 dark:bg-[#1c1f2b] p-4 rounded-xl shadow flex justify-between items-center"
              >
                <div>
                  <p className="font-bold">{user.Phone}</p>
                  <p className="text-sm text-gray-500 dark:text-gray-400">
                    ثبت‌نام: {new Date(user.RegisteredAt).toLocaleDateString('fa-IR')}
                  </p>
                </div>
                <div className="text-sm text-gray-600 dark:text-gray-300">
                  تعداد برنامه‌ها: <strong>{user.TotalPlans}</strong>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* دکمه تغییر تم */}
        <button
          onClick={() => setDark(!dark)}
          className="fixed top-4 right-4 z-50 px-3 py-2 bg-gray-700 text-white rounded-full shadow-lg"
        >
          {dark ? '☀️' : '🌙'}
        </button>
      </div>
    </div>
  );
}
